var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFactechSymbolInk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "t"
  }, "Factech") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "t"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "d"
  }, "Documento entre llaves, en ciruela y sin disco.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#1C1525",
    strokeWidth: 14,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136 187c-8 0-11 6-11 15v41c0 10-6 15-18 15 12 0 18 5 18 15v41c0 9 3 15 11 15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376 187c8 0 11 6 11 15v41c0 10 6 15 18 15-12 0-18 5-18 15v41c0 9-3 15-11 15"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174,
    y: 156,
    width: 164,
    height: 203,
    rx: 12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216 213h80M216 258h80M216 303h64"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFactechSymbolInk);
export default __webpack_public_path__ + "static/media/factech-symbol-ink.90963f94ba207df4cbfbbbd7db6e3e0f.svg";
export { ForwardRef as ReactComponent };